import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getReadoutName } from '../../utils/nameFormat';
export const createReadoutStmtInstruction = `
#### Create readout

- Syntax: \`create readout <readout_name> for <entity_name>;\`
- Example: \`create readout ${getReadoutName('Option')} for Option;\`
- Example: \`create readout ${getReadoutName('Variant')} for Variant;\`
`;
export const stmtCreateReadout = ({ readoutName, viewName, scopeName, entityName }) => {
    if (viewName && scopeName) {
        return `add readout ${readoutName} in ${viewName}.${scopeName} for ${entityName};`;
    }
    return `create readout ${readoutName} for ${entityName};`;
};
export const createReadoutHandler = createStructureStatementHandler({
    type: 'add readout',
    parse: line => {
        const match = /^(add|create) (readout|detail) (?<readoutName>\w+)( in (?<viewName>\w+).(?<scopeName>\w+))? for (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add readout',
                readoutName: match.groups.readoutName,
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
                entityName: match.groups.entityName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addReadout({
                readoutName: stmt.readoutName,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
                entityName: stmt.entityName,
            });
        });
    },
});
//# sourceMappingURL=CreateReadoutStmt.js.map